'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return typeof Object.values === 'function' ? Object.values : implementation;
};



//////////////////
// WEBPACK FOOTER
// ./~/react-outside-click-handler/~/object.values/polyfill.js
// module id = 466
// module chunks = 0